// extracted by mini-css-extract-plugin
export default {"card":"Z4-z"};